import { AuthService } from 'src/app/services/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, private storage: Storage, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    console.log(route)
    if (this.auth.isAuthenticated()) {
      return true;
    }
    else {
      this.router.navigate(["login-user"]);
      return false;
    }



  }
}
